import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon, { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import React, { useContext, useEffect, useState } from "react";
import theme from "../styles/theme";
import Button from "./Button";
import Status from "../types/enum/Status";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import Input from "./Input";
import axios from "axios";
import { VersionContext } from "../context/VersionContext";
import MinimalSelect, { BasicSelect } from "./MinimalSelect";
import SnackBar from "./SnackBar";
import { CancelButton } from "./CourseOverviewModify";

type OptionGroupModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction?: () => void;
  discardFunction?: () => void;
  title?: string;
  description?: string;
  cancelFunction?: () => void;
  optionGroups: any;
  setOptionGroups: any;
  fetchOptionGroups: any;
};
const Title = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const Body = styled.div`
  padding: 10px;
  fontsize: 14px !important;
`;

const Flex = styled(FlexGrow)`
  //   padding: 18px;
  // width: 350px;
  background: #0066ff1a;
  border-radius: 4px;
  //   margin: 24px 0px;
  color: ${theme.color.darkBlueGray300};
`;

const Block = styled("div")`
  display: flex;
  align-items: center;
`;

const OptionGroupModal = ({
  isOpen,
  setOpen,
  confirmFunction,
  discardFunction,
  title,
  description,
  optionGroups,
  setOptionGroups,
  fetchOptionGroups,
}: OptionGroupModalProps): JSX.Element => {
  const [selectedGroup, setSelectedGroup] = useState<{
    option_group_id: string;
    title: string;
    required_count: number;
    curriculum_version: number;
    competencies: any;
  }>({
    option_group_id: "",
    title: "",
    required_count: 0,
    curriculum_version: 0,
    competencies: [],
  });

  const [addGroupOpen, setAddGroupOpen] = useState(false);
  const [newGroup, setNewGroup] = useState("");
  const [addCompOpen, setAddCompOpen] = useState(false);
  const [newComp, setNewComp] = useState("");
  const [competencyOptions, setCompetencyOptions] = useState<any>([]);
  const [selectedCompetency, setSelectedCompetency] = useState("");
  const { version } = useContext(VersionContext);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [editMode, setEditMode] = useState<string>("");
  const [editData, setEditData] = useState<{
    title: string;
    option_group_id: string;
    required_count: number;
  }>({ title: "", option_group_id: "", required_count: 0 });
  const universityCode = localStorage.getItem("university");
  const saveNewGroup = () => {
    axios
      .post("/optiongroup/new", {
        title: newGroup,
        curriculum_version: version.version_number,
      })
      .then((res) => {
        setAddGroupOpen(false);
        setNewGroup("");
        fetchOptionGroups();
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };
  const fetchCompetencies = () => {
    axios
      .get(
        `/competency/summary?university_code=${universityCode}&curriculum_version=${version.version_number}`
      )
      .then((res) => {
        const tempArray: any = [];
        if (res.data.competencies) {
          res.data.competencies.forEach((v: any) => {
            tempArray.push({
              value: v.id,
              label: "[" + v.competency_code + "] " + v.title,
            });
          });
        }
        setCompetencyOptions(tempArray);
      })
      .catch(() => {});
  };
  const addCompetency = () => {
    axios
      .post("/competency/optiongroup/add", {
        template_id: selectedCompetency,
        option_group_id: selectedGroup?.option_group_id,
        curriculum_version: version?.version_number,
      })
      .then((res: any) => {
        fetchOptionGroups();
        setSelectedCompetency("");
        setIsSnackbarOpen(true);
        setMessage(`Added Competency to ${selectedGroup.title}!`);
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  const deleteOptionGroup = (e: any, option_group_id: string) => {
    e.stopPropagation();
    axios
      .delete(`/optiongroup/delete?option_group_id=${option_group_id}`)
      .then((res) => {
        setIsSnackbarOpen(true);
        if (res.data.optionGroupDeleted) {
          option_group_id === selectedGroup.option_group_id &&
            setSelectedGroup({
              option_group_id: "",
              title: "",
              required_count: 0,
              curriculum_version: 0,
              competencies: [],
            });
          setMessage(`Deleted Option Group, ${selectedGroup.title}!`);
        }
        fetchOptionGroups();
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  const editOpen = (
    e: any,
    option_group_id: string,
    title: string,
    required_count: number
  ) => {
    e.stopPropagation();
    setEditMode(option_group_id);
    setSelectedGroup({
      option_group_id: "",
      title: "",
      required_count: 1,
      curriculum_version: 0,
      competencies: [],
    });
    setEditData({
      title: title,
      option_group_id: option_group_id,
      required_count: required_count,
    });
  };

  const submitEditGroup = () => {
    axios
      .put("optiongroup/update", editData)
      .then(() => {
        setIsSnackbarOpen(true);
        setMessage(`Updated the Option Group Successfully!`);
        fetchOptionGroups();
        setEditMode("");
        setEditData({ title: "", option_group_id: "", required_count: 1 });
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  const removeCompetency = (e: any, template_id: string) => {
    // e.stopPropagation();
    axios
      .delete(
        `/competency/optiongroup/remove?template_id=${template_id}&option_group_id=${selectedGroup.option_group_id}`
      )
      .then((res) => {
        if (res.data.competencyOptionGroupDeleted) {
          setIsSnackbarOpen(true);
          setMessage(
            `Removed Competency from ${res.data.competencyOptionGroupDeleted.title}!`
          );
        }
        fetchOptionGroups();
      })
      .catch((err: any) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  useEffect(() => {
    fetchCompetencies();
    selectedGroup.option_group_id !== "" &&
      setSelectedGroup(
        optionGroups?.find(
          (v: any) => v.option_group_id === selectedGroup.option_group_id
        )
      );
  }, [optionGroups]);
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: { minWidth: "900px", padding: "0 16px 24px 16px" },
        }}
      >
        <FlexBox style={{ paddingTop: 15 }}>
          <FlexGrow>
            <Title>
              {/* <Icon color="warning">warning_rounded</Icon> */}
              {title}
            </Title>
          </FlexGrow>
          <ClickableIcon
            name="close"
            // color="white"
            onClick={() => setOpen(false)}
          />
        </FlexBox>
        <FlexBox
          style={{ flexWrap: "nowrap", margin: "10px 0px", borderRadius: 3 }}
          justify="between"
          alignItems="none"
        >
          <Flex>
            <Body>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div> Option Groups</div>
                {!addGroupOpen && (
                  <Button
                    className="reduce_opct_onhover"
                    style={{
                      background: theme.color.blueButton,
                      boxShadow: "0 2px 5px #808080cc",
                      border: "none",
                      width: 120,
                      //   display:'flex',
                      //   alignItems:'center'
                    }}
                    onClick={() => setAddGroupOpen(true)}
                    status={Status.primary}
                    isOutline={false}
                  >
                    <Icon size={3} name={"add"}></Icon>Group
                  </Button>
                )}
              </div>
              {addGroupOpen && (
                <Block
                  style={{
                    justifyContent: "between",
                    gap: 10,
                    marginTop: 10,
                  }}
                >
                  <Input
                    onChange={(e: any) => setNewGroup(e.target.value)}
                    placeholder="New Group Name"
                  />

                  <Button
                    disabled={newGroup === ""}
                    className={newGroup !== "" ? "reduce_opct_onhover" : ""}
                    onClick={() => saveNewGroup()}
                    style={{
                      background: theme.color.blueButton,
                      boxShadow: "0 2px 5px #808080cc",
                      border: "none",
                      // width: 120,
                      //   display:'flex',
                      //   alignItems:'center'
                    }}
                    status={Status.primary}
                    isOutline={false}
                  >
                    <Icon size={3} name={"add"}></Icon>Add
                  </Button>

                  <span
                    onClick={() => {
                      setNewGroup("");
                      setAddGroupOpen(false);
                    }}
                    className="reduce_opct_onhover"
                  >
                    <Icon
                      style={{ cursor: "pointer" }}
                      color="#3a44d6"
                      size={3}
                      name={"close"}
                    ></Icon>
                  </span>
                </Block>
              )}
              <div
                style={{
                  background: "white",
                  borderRadius: 2,
                  marginTop: 10,
                  padding: 5,
                  minHeight: 400,
                }}
              >
                {optionGroups.map((v: any) =>
                  editMode !== v.option_group_id ? (
                    <Block
                      onClick={() => {
                        editMode === "" && setSelectedGroup(v);
                        setNewComp("");
                        setAddCompOpen(false);
                      }}
                      className="hover"
                      style={{
                        justifyContent: "space-between",
                        padding: "5px 10px",
                        fontSize: 14,
                        background:
                          selectedGroup?.option_group_id === v?.option_group_id
                            ? "#0061ff"
                            : "",
                        color:
                          selectedGroup?.option_group_id === v?.option_group_id
                            ? "#ffffff"
                            : "",
                      }}
                    >
                      {v.title}
                      <div>
                        <span
                          className="reduce_opct_onhover"
                          onClick={(e: any) =>
                            editOpen(
                              e,
                              v?.option_group_id,
                              v?.title,
                              v?.required_count
                            )
                          }
                        >
                          <Icon color="black" size={3} name={"edit"} />
                        </span>
                        <span
                          className="reduce_opct_onhover"
                          onClick={(e: any) =>
                            deleteOptionGroup(e, v?.option_group_id)
                          }
                        >
                          <Icon color="red" size={3} name={"delete"} />
                        </span>
                      </div>
                    </Block>
                  ) : (
                    <div style={{ background: "#0066ff1a", padding: 10 }}>
                      <Block
                        style={{
                          padding: "2px 0px",
                        }}
                      >
                        <span style={{ minWidth: 150 }}>Group Title</span>
                        <TextField
                          style={{ width: "100%" }}
                          onChange={(e: any) =>
                            setEditData({ ...editData, title: e.target.value })
                          }
                          value={editData?.title}
                        />
                      </Block>
                      <Block
                        style={{
                          paddingBottom: 10,
                        }}
                      >
                        <span style={{ minWidth: 150 }}>Required Count</span>
                        <TextField
                          type="number"
                          style={{ width: "100%" }}
                          value={editData?.required_count}
                          onChange={(e: any) =>
                            setEditData({
                              ...editData,
                              required_count: parseInt(e.target.value),
                            })
                          }
                        />
                      </Block>
                      <Block
                        style={{
                          justifyContent: "end",
                          gap: 10,
                        }}
                      >
                        <CancelButton
                          className="reduce_opct_onhover"
                          style={{
                            // background: theme.color.blueButton,
                            boxShadow: "0 2px 5px #808080cc",
                            border: "none",
                            width: 120,
                            //   display:'flex',
                            //   alignItems:'center'
                          }}
                          onClick={() => {
                            setEditMode("");
                            setEditData({
                              title: "",
                              option_group_id: "",
                              required_count: 1,
                            });
                          }}
                          status={Status.primary}
                          isOutline={false}
                        >
                          Cancel
                        </CancelButton>
                        <Button
                          className="reduce_opct_onhover"
                          style={{
                            background: theme.color.blueButton,
                            boxShadow: "0 2px 5px #808080cc",
                            border: "none",
                            width: 120,
                            //   display:'flex',
                            //   alignItems:'center'
                          }}
                          onClick={() => submitEditGroup()}
                          status={Status.primary}
                          isOutline={false}
                        >
                          Save
                        </Button>
                      </Block>
                    </div>
                  )
                )}
              </div>
            </Body>
          </Flex>

          {/* competencies list */}
          {selectedGroup?.option_group_id !== "" && (
            <Flex>
              <Body>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    {" "}
                    <span
                      onClick={() =>
                        setSelectedGroup({
                          option_group_id: "",
                          title: "",
                          required_count: 0,
                          curriculum_version: 0,
                          competencies: [],
                        })
                      }
                      className="reduce_opct_onhover"
                    >
                      <Icon
                        color="blue"
                        size={3}
                        name={"keyboard_double_arrow_right_icon"}
                      />
                    </span>
                  </div>
                  {!addCompOpen && (
                    <Button
                      className="reduce_opct_onhover"
                      style={{
                        background: theme.color.blueButton,
                        boxShadow: "0 2px 5px #808080cc",
                        border: "none",
                      }}
                      onClick={() => setAddCompOpen(true)}
                      status={Status.primary}
                      isOutline={false}
                    >
                      <Icon size={3} name={"add"}></Icon>Competency
                    </Button>
                  )}
                </div>
                {addCompOpen && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 10,
                      marginTop: 10,
                    }}
                  >
                    {/* <Input
                      onChange={(e: any) => setNewGroup(e.target.value)}
                      placeholder="New Group Name"
                    /> */}

                    <BasicSelect
                      // value={competencyOptions[0]}
                      onChange={(data: any) => {
                        setSelectedCompetency(data?.value);
                      }}
                      //   menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                          color: "white",
                          minWidth: "10% !important",
                        }),
                        control: (base) => ({
                          ...base,
                          width: "100%",
                          minWidth: "100% !important",
                        }),
                      }}
                      options={competencyOptions}
                    />
                    <Block style={{ gap: 10 }}>
                      <Button
                        disabled={selectedCompetency === ""}
                        className={
                          selectedCompetency !== "" ? "reduce_opct_onhover" : ""
                        }
                        onClick={() => addCompetency()}
                        style={{
                          background: theme.color.blueButton,
                          boxShadow: "0 2px 5px #808080cc",
                          border: "none",
                          // width: 120,
                          //   display:'flex',
                          //   alignItems:'center'
                        }}
                        status={Status.primary}
                        isOutline={false}
                      >
                        <Icon size={3} name={"add"}></Icon>Add
                      </Button>

                      <span
                        onClick={() => {
                          setNewComp("");
                          setAddCompOpen(false);
                        }}
                        className="reduce_opct_onhover"
                      >
                        <Icon
                          style={{ cursor: "pointer" }}
                          color="#3a44d6"
                          size={3}
                          name={"close"}
                        ></Icon>
                      </span>
                    </Block>
                  </div>
                )}
                <div
                  style={{
                    background: "white",
                    borderRadius: 2,
                    marginTop: 10,
                    padding: 5,
                    minHeight: 400,
                  }}
                >
                  {selectedGroup?.competencies.map((v: any) => (
                    <Block
                      style={{
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ padding: "5px 10px", fontSize: 14 }}>
                        {"[" + v.competency_code + "] " + v.title}
                      </div>
                      <span
                        className="reduce_opct_onhover"
                        onClick={(e: any) =>
                          removeCompetency(e, v?.template_id)
                        }
                      >
                        <Icon color="red" size={3} name={"delete"} />
                      </span>
                    </Block>
                  ))}
                </div>
              </Body>
            </Flex>
          )}
        </FlexBox>
      </Modal>
    </>
  );
};

export default OptionGroupModal;
